import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
import type {} from '@mui/x-date-pickers/themeAugmentation';

declare module '@mui/material/styles' {
  interface SimplePaletteColorOptions {
    background?: string;
  }
  interface PaletteColor {
    background: string;
  }
  interface Palette {
    ride: PaletteColor;
    event: PaletteColor;
  }
  interface PaletteOptions {
    ride?: SimplePaletteColorOptions;
    event?: SimplePaletteColorOptions;
  }
}

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      light: '#73a777',
      main: '#509156',
      dark: '#38653c',
      background: '#d6ead7',
    },
    secondary: {
      light: '#F2DDE9',
      main: '#9B4D76',
      dark: '#7A3B5D',
      background: '#F9EDF4',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fafaf8',
    },
    ride: {
      main: '#2E86AB', // Blue NCS
    },
    event: {
      main: '#BB8FA9', // Opera Mauve
    },
  },
  typography: {
    fontFamily: 'var(--font-roboto), "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: 24,
      fontWeight: 700,
      marginTop: 24,
      marginBottom: 24,
    },
    h2: {
      fontSize: 20,
      fontWeight: 700,
      marginTop: 24,
      marginBottom: 8,
    },
    h3: {
      fontSize: 18,
      marginTop: 16,
      marginBottom: 8,
      fontWeight: 700,
    },
    h4: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
      letterSpacing: '0.01071em',
      margin: 0,
      fontWeight: 700,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '0.875rem',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h2: {
          borderBottom: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            backgroundColor: '#fff',
          },
        },
      },
    },
    MuiTimePickerToolbar: {
      styleOverrides: {
        root: {
          '& .MuiPickersToolbarText-root': {
            margin: 0,
            fontSize: undefined,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '& > h2:first-of-type': {
            marginTop: 0,
          },
          '& > h3:first-of-type': {
            marginTop: 0,
          },
        },
      },
    },
  },
});

export default theme;
